export default __webpack_public_path__ + "7a12707114b478b19df67c66451969ab.jpg";